module.exports = __webpack_public_path__ + "static/media/monthlyPricing.c04cf6df.svg";